import styled from "styled-components";

import { FLIGHT_TYPE_CF } from "../../../constants";

export const Wrapper = styled("div")(({ theme, flightType }) => ({
  ...theme.mixins.flexColumn,
  backgroundColor: theme.palette.fly.inputBg,
  width: "auto",
  flex: "1 1 19%",
  minWidth: 180,
  height: 60,
  position: "relative",
  cursor: "pointer",
  transition: "all .2s ease",
  border: "1px solid transparent",
  borderRadius: 6,

  "&:hover": {
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  },

  [theme.down("md")]: {
    width: flightType !== FLIGHT_TYPE_CF ? "100%" : 248,
    flex: "0 0 auto",
  },

  [theme.down("sm")]: {
    width: "100%",
  },
}));

export const ClassBlock = styled("div")(({ theme }) => ({
  ...theme.paddings(4, 15, 0),
  fontSize: 12,
  fontWeight: 500,
  color: theme.palette.fly.placeholder,
}));

export const PassengersCountBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  paddingLeft: 15,
  paddingTop: 2,
}));

export const PassengerCount = styled("div")(({ theme }) => ({
  ...theme.paddings(0, 10, 0, 15),
  fontSize: 14,
  fontWeight: 500,
  color: theme.palette.text.primary,
  position: "relative",

  "& > svg": {
    position: "absolute",
    left: -14,
    top: -10,
  },
}));

export const DropdownIcon = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  padding: 4,
  position: "absolute",
  right: 5,
  top: 18,
  color: theme.palette.fly.placeholder,
  transition: "all .3s ease",
  transform: "rotate(0deg)",

  "&.active": {
    transition: "all .3s ease",
    transform: "rotate(180deg)",
  },
}));

export const DropdownPassengersBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
}));

export const DropdownPassengerItem = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  ...theme.paddings(10, 0),
  borderBottom: `1px solid ${theme.palette.fly.hairline}`,

  "&:last-child": {
    borderBottom: "none",
  },
}));

export const DropdownPassengerItemTitleAndDescription = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  flexGrow: 1,

  "& .title": {
    fontSize: 13,
    fontWeight: 500,
    color: theme.palette.black,
  },

  "& .description": {
    fontSize: 11,
    color: theme.palette.text.muted,
  },
}));

export const CounterBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  gap: 4,
  fontSize: 28,
  color: theme.palette.fly.brand,

  "& span": {
    fontSize: 15,
    fontWeight: 700,
    width: 22,
    textAlign: "center",
    color: theme.palette.black,
  },

  "& > svg": {
    cursor: "pointer",
    color: theme.palette.fly.brand,
    transition: "opacity .2s ease",

    "&.disabled": {
      cursor: "not-allowed",
      color: theme.palette.fly.brand,
      opacity: 0.4,
    },
  },
}));

export const ClassesBlock = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: 6,
  padding: 10,
  marginTop: 15,
  borderRadius: 7,
  backgroundColor: theme.palette.fly.classGroupBg,
}));

export const ClassButton = styled("button")(({ theme, position }) => ({
  ...(position ? { gridColumn: position } : {}),
  backgroundColor: "transparent",
  color: theme.palette.fly.brand,
  border: "none",
  borderRadius: 7,
  height: 38,
  cursor: "pointer",
  transition: "all .2s ease",
  fontWeight: 600,
  fontSize: 13,
  letterSpacing: "0.03em",

  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.6)",
  },

  "&.active": {
    backgroundColor: theme.palette.white,
    color: theme.palette.fly.brand,
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",

    "&:hover": {
      backgroundColor: theme.palette.white,
    },
  },
}));
